import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location  } from '@angular/common';
import { ChaseInvoiceStatus } from './Model/ChaseInvoiceStatus';
import { InvoiceStatusService } from './Service/invoice-status.service';

@Component({
    selector: 'app-invoice-status',
    templateUrl: './invoice-status.component.html',
    styleUrls: ['./invoice-status.component.css'],
    providers: [InvoiceStatusService],
    standalone: false
})
export class InvoiceStatusComponent implements OnInit {

  uId: string;
  status: string;

  transactionStatus: ChaseInvoiceStatus = new ChaseInvoiceStatus();

  constructor(private location: Location, private router: Router, private invoiceStatusService: InvoiceStatusService) { }

  ngOnInit() {

    this.location.subscribe(change => {
      if(!change.url.includes("uId"))
        this.router.navigate(['Invoice']);
    });

    // debugger;
    this.uId = this.router.parseUrl(this.router.url).queryParams['uId'];
    this.invoiceStatusService.getTransactionStatusFromUID(this.uId).subscribe(
      (p: ChaseInvoiceStatus) => {
        // debugger;
        this.transactionStatus = p;
        if (this.transactionStatus.transactionStatus === 'Success') {
          this.status = 'Success';
        } else {
          this.status = 'Failure';
        }
      });
  }

  home() {
    this.router.navigate(['Invoice']);
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>MediaPay - Invoice Payment Successful</title>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );

    let btn = popupWin.document.getElementById('goToHome');
    btn.parentNode.removeChild(btn);
    popupWin.document.close();
  }

}
